import React from 'react';
import {
  CalendarToday,
  LocationOn,
  People,
  EmojiEvents,
  Restaurant,
  Public,
  Celebration
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import ImageCarousel from '../../components/events/ImageCarousel';
import EventMeta from '../../components/events/EventMeta';
import KeyTakeaways from '../../components/events/KeyTakeaways';
import styled from 'styled-components';

const ClosingMessage = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-top: 48px;
  margin-bottom: 60px;
  border: 1px solid rgba(0,0,0,0.1);

  h3 {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-text);
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    color: var(--color-text-light);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const Evenement = () => {
  const eventData = {
    title: "SHALOM's First Public Appearance at Vivapoly",
    description: "We made our debut at EPFL's Vivapoly festival! Our stand featured traditional Israeli falafels, interactive quizzes about Israeli culture, and engaging discussions about our association's mission and future projects.",
    date: "23/05/2024",
    location: "EPFL Campus - Vivapoly Festival",
    category: "Association Event",
    media: [
      { src: "/events/vivap24/vivap1.jpg", objectFit: 'cover', objectPosition: 'center' },
      { src: "/events/vivap24/vivap2.jpg", objectFit: 'cover', objectPosition: '50% 60%' },
      { src: "/events/vivap24/vivap3.jpg", objectFit: 'cover', objectPosition: '50% 80%' }
    ],
    keyTakeaways: [
      {
        icon: <EmojiEvents style={{ fontSize: '24px' }} />,
        title: 'Major Milestone',
        description: "Our association's first public event marked a significant step in establishing our presence at EPFL.",
        color: '#4F8EF7'
      },
      {
        icon: <People style={{ fontSize: '24px' }} />,
        title: 'Community Engagement',
        description: "Over 100 visitors stopped by our stand, learning about Israeli culture and our association's initiatives.",
        color: '#9C88FF'
      },
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Cultural Experience',
        description: 'Visitors enjoyed authentic Israeli falafels, providing a taste of traditional Middle Eastern cuisine.',
        color: '#50E3C2'
      },
      {
        icon: <Public style={{ fontSize: '24px' }} />,
        title: 'Cultural Exchange',
        description: 'Interactive quizzes and fun facts about Israeli culture, history, and tech industry fostered learning and dialogue.',
        color: '#FF6B9D'
      },
      {
        icon: <Celebration style={{ fontSize: '24px' }} />,
        title: 'Festival Success',
        description: 'The event provided an excellent platform to introduce our association to the EPFL community.',
        color: '#FFB74D'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4F8EF7, #9C88FF)',
      title: eventData.date,
      subtitle: 'Event Date'
    },
    {
      icon: <LocationOn style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: eventData.location,
      subtitle: 'Location'
    },
    {
      icon: <People style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: '100+ Visitors',
      subtitle: 'Event Attendance'
    }
  ];

  return (
    <EventLayout>
      <BackButton />
      <EventHero
        category={eventData.category}
        title={eventData.title}
        description={eventData.description}
      >
        <EventMeta items={metaItems} />
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
      />

      <KeyTakeaways items={eventData.keyTakeaways} />

      <ClosingMessage>
        <h3>Event Impact & Success</h3>
        <p>
          Our first participation in Vivapoly was a remarkable success! The event allowed us to connect with the EPFL community, share our vision, and celebrate Israeli culture through food and interactive activities. We received overwhelmingly positive feedback from visitors who enjoyed learning about Israel's rich culture, innovative tech industry, and diverse traditions through our engaging quizzes and discussions.
          <br /><br />
          Thank you to everyone who visited our stand and made this event truly special. This marks just the beginning of our journey to foster cultural exchange and build bridges within the EPFL community.
        </p>
      </ClosingMessage>
    </EventLayout>
  );
};

export default Evenement;